<div class="offer-bottom-popup">
  <!-- <ion-icon name="close-outline" (click)="close()"
    style="font-size: 2rem; position: fixed; color: #F5739F; z-index: 1; right: 40px;">
  </ion-icon> -->
  <ion-icon
    name="close-circle"
    class="padding-horizontal-5 close-i success-color closed"
    (click)="close()"
  ></ion-icon>
  <ion-card>
    <ion-card-header class="ion-text-center" style="padding-bottom: 0">
      <img src="assets/img/meal-alarm-clock.png" />
    </ion-card-header>
    <ion-card-content class="ion-margin-horizontal" *ngIf="!onFast">
      <div style="font-size: 1rem; font-weight: bold">
        Are you ready to fast now?
      </div>
      <div style="font-size: 0.8rem">
        You can start your fasting window prematurely, or let us remind you
        later
      </div>

      <ion-item class="line-height-2" *ngIf="!onFast">
        <ion-label position="fixed" class="width50">From</ion-label>
        <ion-datetime
          style="padding-right: 0"
          slot="end"
          displayFormat="HH:mm"
          mode="ios"
          [(ngModel)]="fromTimeFasting"
          [value]="fromTimeFasting"
          (ionChange)="changeTime($event, false)"
          [max]="maxTime"
          [min]="minTime"
        >
          <!-- [hourValues]='hours' [minuteValues]='minutes'> -->
        </ion-datetime>
      </ion-item>

      <ion-row class="ion-margin">
        <ion-col class="ion-text-center">
          <ion-button class="start-fasting" (click)="startFasting()"
            >Start Fasting</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-card-content>

    <ion-card-content
      class="ion-margin-horizontal"
      *ngIf="onFast"
      style="margin-top: 0"
    >
      <div style="font-size: 1rem; font-weight: bold">End Fasting?</div>
      <div style="font-size: 0.8rem">
        You haven't reached your goal yet. Are you sure you want to end this
        fast prematurely?
      </div>

      <ion-item class="line-height-2" *ngIf="onFast">
        <ion-label position="fixed" class="width50">From</ion-label>
        <ion-datetime
          style="padding-right: 0"
          slot="end"
          displayFormat="HH:mm"
          mode="ios"
          [(ngModel)]="endTimeFasting"
          [value]="endTimeFasting"
          (ionChange)="changeTime($event, true)"
          [max]="maxTime"
          [min]="minTime"
        >
        </ion-datetime>
      </ion-item>

      <ion-row class="ion-margin">
        <ion-col class="ion-text-center">
          <ion-button
            class="start-fasting"
            expand="block"
            (click)="endFasting(true)"
            >Yes</ion-button
          >
        </ion-col>
        <ion-col size="1"></ion-col>
        <ion-col class="ion-text-center">
          <ion-button
            fill="outline"
            expand="block"
            class="set-alarm"
            (click)="endFasting(false)"
            >No</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</div>
